<template>
  <div class="echart">
    <div  id="cheweiChart" :style="myChartStyle"></div>
    <div id="tousuChart" :style="myChartStyle1"></div>
    <div id="zhifuChart" :style="myChartStyle2"></div>
  </div>

</template>

<script>
import * as echarts from 'echarts';

export default {
  // name: 'PieChart',
  data() {
    return {
      xData: [], //横坐标
      yData: [0, 0, 0, 0, 27, 0, 25], //数据
      pieData: [],
      xian: 0,
      feixian: 0,
      baoxiu: 0,
      tousu: 0,
      zhifu: 0,
      weizhifu: 0,
      myChartStyle: { float: "left", width: "50%", height: "350px" }, //图表样式
      myChartStyle1: { float: "right", width: "50%", height: "350px" }, //图表样式
      myChartStyle2: { position: "absolute", bottom:0, width: "50%", height: "350px" } //图表样式
    };
  },
  mounted() {
    this.initDate();
    this.initDate1();
    this.initDate2();
  },
  methods: {
    initDate() {
      debugger
      // 旅游景点
      this.$http({
        url: "cheweixinxi/echartData",
        method: "post",
      }).then(({ data }) => {
        debugger;
        this.xian = data.data.xian;
        this.feixian = data.data.feixian;

        console.log("：：："+this.feixian)
        this.initEcharts();

      });
    },
    initDate1() {
      debugger
      // 旅游景点
      this.$http({
        url: "messages/echartData",
        method: "post",
      }).then(({ data }) => {
        debugger;
        this.baoxiu = data.data.baoxiu;
        this.tousu = data.data.tousu;

        console.log("：：："+this.feixian)
        this.initEcharts1();

      });
    },
    initEcharts() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.getElementById("cheweiChart"));
      // 指定图表的配置项和数据
      const option = {
        title: {
          text: '车位占比',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
        },
        series: [
          {
            name: '车位占比',
            type: 'pie',
            radius: '50%',
            data: [
              {value: this.xian, name: '空闲车位'},
              {value: this.feixian, name: '已用车位'},
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    initEcharts1() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.getElementById("tousuChart"));
      // 指定图表的配置项和数据
      const option = {
        title: {
          text: '报修和投诉占比',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
        },
        series: [
          {
            name: '报修和投诉占比',
            type: 'pie',
            radius: '50%',
            data: [
              {value: this.baoxiu, name: '报修'},
              {value: this.tousu, name: '投诉'},
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    }
  }
};
</script>
